import type { Concept, ConceptId } from "./types";
import { paper } from "./paper";
import { console as consoleConcept } from "./console";
import { focus } from "./focus";

export const CONCEPTS: Record<ConceptId, Concept> = {
  paper,
  console: consoleConcept,
  focus,
};

export const CONCEPT_ORDER: ConceptId[] = ["paper", "console", "focus"];

export function isConceptId(v: unknown): v is ConceptId {
  return v === "paper" || v === "console" || v === "focus";
}

export type { Concept, ConceptId } from "./types";
